import { BaseService } from './base';
import { ServiceAutomation } from '../models/serviceAutomation';

/**
 * Stub service for ServiceAutomation model registration.
 * CRUD operations are managed through ServiceService
 * (addAutomation, updateAutomation, removeAutomation).
 */
export class ServiceAutomationService extends BaseService<ServiceAutomation> {
  override model = ServiceAutomation;
  override modelName = 'serviceAutomation';
  override modelLabel = 'Service Automation';
}